import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationLoaderService } from 'src/app/services/translate-loader.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-language-dropdown',
  templateUrl: './language-dropdown.component.html',
  styleUrls: ['./language-dropdown.component.scss']
})
export class LanguageDropdownComponent implements OnInit {
  projectName = environment.projectName
  supportedLanguage: any;
  currentSelectedLanguage: string;
  @Input() colorScheme: string = '';
  @Input() refreshDropdown: boolean = false;
  @Output() onLanguageChange = new EventEmitter<string>();

  constructor(
    private translationService : TranslationLoaderService,  
    private translate: TranslateService) { }

  ngOnInit() {

    //reading language supported from environment file variable 
    this.supportedLanguage = JSON.parse(environment.supportedLanguages);

    //setting language selected last time
    this.currentSelectedLanguage = this.translate.currentLang;

  }

  ngOnChanges(){
    if(this.refreshDropdown){
      let lang = localStorage.getItem('user_lng');
      this.currentSelectedLanguage =  lang;
    }
  }

  //function to change language
  changeLanguage(language: string) {
    
    //setting language
    localStorage.setItem('user_lng', language);
    this.translate.use(language);
    this.translationService.getTranslation(language);

    //setting language selected to highlight on UI
    this.currentSelectedLanguage =  language;
    this.onLanguageChange.emit(language);
  }

}
